export const cssClassNames = {
    inactiveRow: 'inactive-row',
    centeredChildren: 'd-flex justify-content-center align-items-center'
};
